export class AppConsts {

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static workbookBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Intelec'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'studio_enc_auth_token',
        refreshTokenName: 'refresh_token',
        authTokenName: 'access_token'
    };
}
